import {
	ChangeDetectionStrategy,
	Component,
	signal,
	OnInit,
	inject,
} from '@angular/core';
import { $clientIntakePageViewModels } from './view-models/selectors';
import { select } from '@ngxs/store';
import { TestHooks } from './client-intake-page.hooks';
import { IntakeHeaderComponent } from './components/intake-header/intake-header.component';
import { ButtonSegmentedComponent } from 'src/app/ui/button-segmented/button-segmented.component';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { TestHookDirective } from '@core/ui';
import { PortalInviteStatus } from '@models/portal-invites';
import { IntakeSidePanelComponent } from './components/intake-side-panel/intake-side-panel.component';
import { IntakeFormPreviewComponent } from './components/intake-form-preview/intake-form-preview.component';
import { IntakeFormMode } from './view-models/models';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
	selector: 'app-client-intake',
	templateUrl: './client-intake-page.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		IntakeHeaderComponent,
		ButtonSegmentedComponent,
		AtomicModule,
		TestHookDirective,
		IntakeSidePanelComponent,
		IntakeFormPreviewComponent,
	],
})
export class ClientIntakePageComponent implements OnInit {
	testHooks = TestHooks;
	PortalInviteStatus = PortalInviteStatus;
	viewModels_ = select($clientIntakePageViewModels);

	private route = inject(ActivatedRoute);
	private router = inject(Router);

	IntakeFormMode = IntakeFormMode;

	formMode_ = signal<IntakeFormMode>(IntakeFormMode.EDIT);

	ngOnInit(): void {
		this.route.queryParamMap
			.pipe(untilDestroyed(this))
			.subscribe((paramMap) => {
				const formModeParam = paramMap.get('mode') as
					| IntakeFormMode
					| undefined;

				if (
					formModeParam &&
					Object.values(IntakeFormMode).includes(formModeParam)
				) {
					this.changeFormMode(formModeParam);
				} else {
					this.changeFormMode(IntakeFormMode.PREVIEW);
				}
			});
	}

	changeFormMode(newMode: IntakeFormMode): void {
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: { mode: newMode },
			queryParamsHandling: 'merge',
			replaceUrl: true,
		});

		this.formMode_.set(newMode);
	}
}
